/**
 * Hebrew UI dictionary. Components never hardcode display text — they call
 * `t('key')`, which keeps a future second language a data change (plan 32).
 */
export const he = {
  'app.name': 'שבצ״ק',
  'app.tagline': 'מערכת שיבוץ כוח אדם',
  'app.loading': 'טוען…',
  'app.saving': 'שומר…',
  'app.retry': 'נסו שוב',
  'app.cancel': 'ביטול',
  'app.save': 'שמירה',
  'app.close': 'סגירה',
  'app.search': 'חיפוש',
  'app.filters': 'סינון',
  'app.clearFilters': 'ניקוי סינון',
  'app.all': 'הכול',
  'app.none': 'ללא',
  'app.actions': 'פעולות',
  'app.today': 'היום',
  'app.back': 'חזרה',
  'app.offline': 'אין חיבור לרשת. המידע המוצג עשוי להיות לא מעודכן.',
  'app.lastSync': 'סונכרן לאחרונה ב־{time}',
  'app.commandPalette': 'חיפוש ופעולות מהירות',
  'palette.placeholder': 'חיפוש אדם, מסך או פעולה…',
  'palette.screens': 'מסכים',
  'palette.people': 'אנשים',
  'palette.actions': 'פעולות',
  'palette.empty': 'אין תוצאה לחיפוש הזה.',
  'palette.hint': 'חיצים לניווט, Enter לבחירה, Esc לסגירה.',
  'palette.open': 'חיפוש מהיר',
  'palette.shortcut': 'Ctrl+K',
  'app.openMenu': 'פתיחת התפריט',
  'app.closeMenu': 'סגירת התפריט',
  'app.skipToContent': 'דילוג לתוכן הראשי',
  'app.more': 'עוד',
  'app.moreActions': 'פעולות נוספות',
  'app.step': 'שלב {n}',
  'app.howItWorks': 'איך זה עובד',

  'nav.dashboard': 'לוח בקרה',
  'nav.schedule': 'שבצ״ק',
  'nav.personnel': 'כוח אדם',
  'nav.availability': 'זמינות ונוכחות',
  'nav.assignments': 'סוגי משימות',
  'nav.replacements': 'בקשות החלפה',
  'nav.notifications': 'התראות',
  'nav.reports': 'דוחות',
  'nav.settings': 'הגדרות',
  'nav.mySchedule': 'השבצ״ק שלי',
  'nav.conflicts': 'התנגשויות',
  'nav.account': 'החשבון שלי',
  'theme.toDark': 'מעבר למצב כהה',
  'theme.toLight': 'מעבר למצב בהיר',
  'theme.followDevice': 'לפי הגדרת המכשיר',
  'theme.following': 'כרגע לפי המכשיר',

  'auth.title': 'כניסה למערכת',
  'auth.subtitle': 'הזינו את שם המשתמש והסיסמה שקיבלתם מהמפקד.',
  'auth.email': 'שם משתמש',
  'auth.password': 'סיסמה',
  'auth.submit': 'כניסה',
  'auth.logout': 'התנתקות',
  'auth.loggedInAs': 'מחובר כ־{name}',
  'auth.sessionExpired': 'החיבור פג. יש להתחבר מחדש.',
  'auth.mfaTitle': 'אימות דו־שלבי',
  'auth.mfaPrompt': 'הזינו את הקוד מאפליקציית האימות, או קוד שחזור.',
  'auth.mfaCode': 'קוד אימות',
  'auth.mfaSubmit': 'אישור',
  'auth.mfaBack': 'חזרה',

  'mfa.title': 'אימות דו־שלבי',
  'mfa.subtitle': 'שכבת הגנה שנייה: מלבד הסיסמה נדרש קוד מתחלף מהטלפון.',
  'mfa.statusOn': 'מופעל',
  'mfa.statusOff': 'כבוי',
  'mfa.start': 'הפעלת אימות דו־שלבי',
  'mfa.stop': 'ביטול אימות דו־שלבי',
  'mfa.step1': 'הוסיפו את המפתח הזה לאפליקציית אימות (Google Authenticator, Authy וכדומה).',
  'mfa.secret': 'מפתח להזנה ידנית',
  'mfa.uri': 'או הדביקו את הכתובת הזאת באפליקציה',
  'mfa.step2': 'הזינו את הקוד שהאפליקציה מציגה, כדי לוודא שהמפתח נקלט.',
  'mfa.enabled': 'האימות הדו־שלבי הופעל.',
  'mfa.disabled': 'האימות הדו־שלבי בוטל.',
  'mfa.recoveryTitle': 'קודי שחזור',
  'mfa.recoveryHint':
    'שמרו אותם במקום בטוח — כל אחד משמש פעם אחת, והם הדרך היחידה להיכנס אם הטלפון אבד. הם מוצגים עכשיו בלבד.',
  'mfa.recoveryCopy': 'העתקה',
  'mfa.recoveryCopied': 'הקודים הועתקו',
  'mfa.recoveryDownload': 'הורדה כקובץ',
  'mfa.confirmPassword': 'אישור בסיסמה',
  'mfa.reset': 'איפוס אימות דו־שלבי',
  'mfa.resetConfirm':
    'לאפס את האימות הדו־שלבי של {name}? הוא יוכל להיכנס עם סיסמה בלבד עד שיגדיר מחדש.',

  'dashboard.title': 'לוח בקרה',
  'dashboard.subtitle': 'תמונת מצב של היום — מי זמין, מה כבר משובץ ומה עוד דורש טיפול.',
  'dashboard.available': 'זמינים',
  'dashboard.unavailable': 'לא זמינים',
  'dashboard.assigned': 'משובצים היום',
  'dashboard.issues': 'בעיות',
  'dashboard.understaffed': 'משימות בתת־איוש',
  'dashboard.openSeats': 'מקומות פנויים היום',
  'dashboard.onDuty': 'מי בתפקיד עכשיו',
  'dashboard.onDutyHint': 'המשמרות שמתקיימות ברגע זה, והזמן עד ההחלפה.',
  'dashboard.noneOnDuty': 'אין משמרת פעילה כרגע.',
  'dashboard.handoverIn': 'החלפה בעוד {time}',
  'dashboard.seatEmpty': 'לא מאויש',
  'dashboard.upcoming': 'המשימות הקרובות',
  'dashboard.alerts': 'התראות שיבוץ',
  'dashboard.recentChanges': 'שינויים אחרונים',
  'dashboard.quickActions': 'פעולות מהירות',
  'dashboard.ofPersonnel': 'מתוך {count} אנשי כוח אדם',
  'dashboard.noIssues': 'אין התנגשויות פתוחות.',
  'dashboard.noUpcoming': 'אין משימות קרובות בטווח המוצג.',

  'setup.title': 'הצעדים הראשונים',
  'setup.subtitle': 'עברו על השלבים לפי הסדר. הכרטיס נעלם מעצמו כשכולם הושלמו.',
  'setup.remaining': 'נותרו {count} שלבים',
  'setup.units': 'הגדירו מסגרות',
  'setup.unitsHint': 'פלוגה, מחלקות, צוותים — כדי לסנן ולשבץ לפי מסגרת.',
  'setup.qualifications': 'הגדירו הכשירים',
  'setup.qualificationsHint': 'מה אדם מוסמך לעשות — נהג, מפקד, חובש. השיבוץ האוטומטי נשען על זה.',
  'setup.personnel': 'הוסיפו כוח אדם',
  'setup.personnelHint': 'אחד־אחד, או בייבוא קובץ CSV של כל המערך בבת אחת.',
  'setup.types': 'הגדירו סוגי משימות',
  'setup.typesHint': 'סיור, ש.ג, שער — כמה אנשים דרושים, לכמה זמן ואילו הכשירים חייבים בצוות.',
  'setup.schedule': 'בנו את השבצ״ק',
  'setup.scheduleHint': 'צרו משימות ליום, הריצו שיבוץ אוטומטי ופרסמו לחיילים.',
  'setup.done': 'הושלם',
  'setup.go': 'מעבר',

  'schedule.title': 'שבצ״ק',
  'schedule.subtitle':
    'לוח המשמרות. כאן פורסים את המשימות הקבועות לתקופה, משבצים אנשים ומייצאים את הדף ל־PDF.',
  'schedule.roster': 'לוח משמרות',
  'schedule.rosterShort': 'לוח',
  'schedule.byPersonnelShort': 'אדם',
  'schedule.seatEmpty': 'טרם שובץ',
  'schedule.notesColumn': 'הערות',
  'schedule.sheetTitle': 'משימות לתאריך {date} · יום {weekday}',
  'schedule.dragCardHint': 'גררו כדי להעביר את העמדה למקום אחר בגיליון',
  'schedule.openPostHint': 'לחצו על שם המשימה לפעולות נוספות',
  'schedule.postShiftsToday': '{count} משמרות בתאריך המוצג',
  'schedule.postNoShiftsToday': 'אין משמרות בתאריך המוצג',
  'schedule.postSettings': 'הגדרות סוג המשימה',
  'schedule.postClearDay': 'הסרת {count} משמרות היום מהלוח',
  'schedule.postClearDayConfirm':
    'כל משמרות המשימה בתאריך המוצג יורדו מהלוח. משמרת שאיש לא משובץ אליה תימחק לגמרי; משמרת שמישהו עומד בה תבוטל ותישאר לתיעוד. המשימה עצמה נשארת ותמשיך להיפרס בימים אחרים.',
  'schedule.postClearDayDone': 'ירדו מהלוח: {deleted} נמחקו, {cancelled} בוטלו.',
  'schedule.postDelete': 'מחיקת המשימה מכל הימים',
  'schedule.layoutSaved': 'סדר הגיליון נשמר',
  'schedule.layoutFailed': 'לא הצלחנו לשמור את סדר הגיליון',
  'schedule.moved': '{name} הועבר',
  'schedule.swapped': '{name} ו{other} החליפו מקומות',
  'schedule.moveFailed': 'לא הצלחנו להעביר את {name}',
  'schedule.undo': 'ביטול',
  'schedule.undoHint': 'ביטול הפעולה האחרונה בלוח',
  'schedule.undone': 'הפעולה בוטלה',
  'schedule.role': 'תפקיד',
  'schedule.rolePlain': 'לוחם',
  'schedule.roleTaken': 'התפקיד תפוס במשימה',
  'schedule.seatNeedsQualification':
    '{name} אינו מחזיק בהכשיר {qualification} ולא ניתן לשבצו לתפקיד.',
  'schedule.seatOnlyForHolders': 'רק מי שמחזיק בהכשיר {qualification} מוצג כאן.',
  'schedule.assignToSeat': 'משבצים לתפקיד:',
  'schedule.day': 'יום',
  'schedule.week': 'שבוע',
  'schedule.byPersonnel': 'לפי אדם',
  'schedule.byAssignment': 'לפי משימה',
  'schedule.newAssignment': 'משימה חדשה',
  'schedule.missingPerson': 'חסר {count} אנשים',
  'schedule.missingOne': 'חסר אדם אחד',
  'schedule.emptyDay': 'אין משימות בתאריך זה.',
  'schedule.previousDay': 'יום קודם',
  'schedule.nextDay': 'יום הבא',
  'schedule.selectSchedule': 'בחירת שבצ״ק',
  'schedule.noSchedule': 'טרם נוצר שבצ״ק. צרו אחד כדי לפרסם משימות.',
  'schedule.createSchedule': 'יצירת שבצ״ק',
  'schedule.name': 'שם השבצ״ק',
  'schedule.range': 'טווח תאריכים',
  'schedule.validate': 'בדיקת תקינות',
  'schedule.assignPerson': 'שיבוץ אדם',
  'schedule.unassign': 'הסרת שיבוץ',
  'schedule.hoursHeader': 'שעות',
  'schedule.autofill': 'שיבוץ אוטומטי',
  'schedule.autofillTitle': 'הצעת שיבוץ אוטומטית',
  'schedule.autofillSubtitle': 'ההצעה אינה נשמרת עד לאישורכם. אפשר להסיר כל שורה לפני האישור.',
  'schedule.autofillEmpty': 'כל המשימות בטווח כבר מאוישות.',
  'schedule.autofillProposed': '{count} שיבוצים מוצעים',
  'schedule.autofillGaps': '{count} מקומות שלא ניתן לאייש',
  'schedule.demand':
    'היום דורש {hours} שעות־אדם, ויש {people} אנשים במאגר — {perPerson} שעות לאדם בממוצע.',
  'schedule.autofillSwaps': '{count} מקומות אוישו על ידי העברת אדם ממשימה אחרת',
  'schedule.demandOverLimit':
    'זה מעל מגבלת השיבוץ הרצוף. אי אפשר לאייש את היום הזה בלי שמישהו יחרוג — צריך יותר אנשים, פחות עמדות או משמרות קצרות יותר.',
  'schedule.autofillApply': 'אישור {count} שיבוצים',
  'schedule.autofillApplied': 'שובצו {count} אנשים',
  'schedule.autofillRejected': '{count} שיבוצים נדחו בבדיקה חוזרת',
  'schedule.autofillComputing': 'מחשב הצעה…',
  'schedule.autofillRemove': 'הסרה מההצעה',
  'schedule.standing': 'פריסת תקופה',
  'schedule.standingTitle': 'פריסת המשימות הקבועות לתקופה',
  'schedule.standingSubtitle':
    'המשימות הקבועות רצות מסביב לשעון ואינן נקבעות מחדש כל בוקר. בחרו תקופה — כל המשמרות שלה ייווצרו בבת אחת.',
  'schedule.standingFrom': 'מתאריך',
  'schedule.standingTo': 'עד תאריך',
  'schedule.standingPosts': 'משימות קבועות: {names}',
  'schedule.standingNoPosts':
    'אף סוג משימה אינו מסומן כקבוע. סמנו "משימה קבועה" במסך סוגי המשימות.',
  'schedule.standingCrew': '{count} אנשים למשמרת',
  'schedule.standingRepeat': 'אפשר להריץ שוב מתי שרוצים — משמרת שכבר קיימת לא תיווצר פעמיים.',
  'schedule.standingCreate': 'פריסה',
  'schedule.standingDone': 'נוצרו {created} משמרות ({skipped} כבר היו קיימות).',
  'schedule.standingNothing': 'כל המשמרות בתקופה כבר קיימות.',
  'schedule.endBeforeStart':
    'שעת הסיום חייבת להיות אחרי שעת ההתחלה. סמנו "מסתיימת למחרת" למשמרת שחוצה חצות.',
  'schedule.editAssignment': 'עריכת המשימה',
  'schedule.cancelAssignment': 'ביטול המשימה',
  'schedule.cancelAssignmentConfirm':
    'המשימה תרד מהלוח. השיבוצים שנעשו בה נשמרים בהיסטוריה ואינם נמחקים.',
  'schedule.cancelled': 'המשימה בוטלה.',
  'schedule.removeAssignment': 'הסרת המשימה מהלוח',
  'schedule.removeAssignmentConfirm':
    'המשימה תוסר מהלוח. משמרת עתידית שאיש לא משובץ אליה תימחק לגמרי; משמרת שמישהו עומד בה תבוטל ותישאר לתיעוד.',
  'schedule.deleted': 'המשימה נמחקה.',
  'schedule.saveAssignment': 'שמירת השינויים',
  'schedule.unassignDay': 'הסרה מכל משימות היום',
  'schedule.unassignDayDone': 'הוסר מ־{count} משימות באותו היום.',
  'schedule.unassignDone': 'השיבוץ הוסר.',
  'schedule.clearDay': 'ניקוי שיבוצי היום',
  'schedule.clearDayHint': 'מסיר את כל האנשים ממשימות {date}. המשימות עצמן נשארות, ריקות.',
  'schedule.clearDayConfirm':
    'לנקות את כל השיבוצים של {date}? כל האנשים יוסרו מהמשימות של היום הזה. המשימות עצמן יישארו, ריקות ומוכנות לשיבוץ מחדש.',
  'schedule.clearDayDone': 'הוסרו {removed} שיבוצים מ־{assignments} משימות בתאריך {date}.',
  'schedule.clearDayEmpty': 'לא נמצאו שיבוצים לתאריך {date}.',
  'schedule.candidateSearch': 'חיפוש חייל ברשימה',
  'schedule.candidateSearchPlaceholder': 'שם החייל…',
  'schedule.candidatesShown': 'מוצגים {shown} מתוך {total} אנשים',
  'schedule.candidatesNoMatch': 'אין חייל בשם הזה ברשימת המועמדים.',
  'schedule.overrideBlocked': 'השיבוץ חסום. כדי לשבץ בכל זאת, הזינו סיבה ואשרו.',
  'schedule.overrideNotAllowed': 'הכלל הזה אינו ניתן לעקיפה, ולכן לא ניתן לשבץ כאן.',
  'schedule.overrideNoPermission': 'אין לך הרשאה לעקוף כלל חוסם. פנו למפקד הפלוגה.',
  'schedule.overrideDone': 'השיבוץ בוצע כחריגה מתועדת.',
  'schedule.print': 'ייצוא PDF',
  'schedule.printHint': 'מדפיס את התצוגה הנוכחית. בחלון ההדפסה בחרו "שמירה כ־PDF".',
  'schedule.view': 'תצוגה',
  'schedule.dateRange': 'תאריך',
  'schedule.unitFilter': 'סינון לפי מסגרת',
  'schedule.summaryTasks': '{count} משימות',
  'schedule.summaryStaffed': '{filled} מתוך {needed} מקומות מאוישים',
  'schedule.summaryFull': 'כל המקומות מאוישים',
  'schedule.summaryMissing': 'חסרים {count} אנשים',
  'schedule.summaryConflicts': '{count} התנגשויות',
  'schedule.summaryNoConflicts': 'אין התנגשויות',
  'schedule.step1': 'פרסו את המשימות הקבועות לכל התקופה — פעם אחת',
  'schedule.step2': 'הריצו שיבוץ אוטומטי והשלימו ידנית',
  'schedule.step3': 'ייצאו PDF ושלחו בקבוצה',
  'schedule.emptyDayHint': 'פרסו את המשימות הקבועות לתקופה, או צרו משימה חד־פעמית אחת ליום הזה.',
  'schedule.autofillNeedsAssignments': 'קודם צרו משימות ליום — השיבוץ האוטומטי ממלא משימות קיימות.',

  'personnel.title': 'כוח אדם',
  'personnel.subtitle': 'מאגר האנשים שאפשר לשבץ — עם המסגרת, התפקיד וההכשירים של כל אחד.',
  'personnel.add': 'הוספת איש כוח אדם',
  'personnel.edit': 'עריכת פרטים',
  'personnel.name': 'שם',
  'personnel.externalId': 'מספר אישי',
  'personnel.unit': 'מסגרת',
  'personnel.roleTitle': 'תפקיד',
  'personnel.phone': 'טלפון',
  'personnel.status': 'סטטוס',
  'personnel.notes': 'הערות',
  'personnel.qualifications': 'הכשירים',
  'personnel.statusActive': 'פעיל',
  'personnel.statusInactive': 'לא פעיל',
  'personnel.statusArchived': 'בארכיון',
  'personnel.empty': 'לא נמצאו אנשים התואמים לסינון.',
  'personnel.emptyAll': 'עדיין אין אנשים במאגר. הוסיפו אדם אחד, או ייבאו את כל המערך מקובץ CSV.',
  'personnel.archive': 'העברה לארכיון',
  'personnel.archiveConfirm': 'להעביר את {name} לארכיון? השיבוצים הקיימים יישמרו.',
  'personnel.searchPlaceholder': 'חיפוש לפי שם, מספר אישי או תפקיד',
  'personnel.allUnits': 'כל המסגרות',
  'personnel.allQualifications': 'כל ההכשירים',
  'personnel.count': '{count} אנשים',
  'personnel.countOne': 'אדם אחד',
  'personnel.import': 'ייבוא מקובץ',
  'personnel.importTitle': 'ייבוא כוח אדם מקובץ CSV',
  'personnel.importNewUnits': 'מסגרות חדשות שייווצרו: {names}',
  'personnel.importNewQualifications': 'הכשירים חדשים שייווצרו: {names}',
  'import.chooseFile': 'בחירת קובץ',
  'import.paste': 'או הדביקו כאן את תוכן הקובץ',
  'import.template': 'הורדת תבנית',
  'import.columns': 'עמודות שזוהו',
  'import.check': 'בדיקה',
  'import.confirm': 'ייבוא {count} רשומות',
  'import.parsed': 'נקראו {count} רשומות',
  'import.ready': '{count} רשומות מוכנות לייבוא',
  'import.checking': 'בודק מול השרת…',
  'import.awaitCheck': 'ממתין לבדיקה',
  'import.skipped': '{count} רשומות ידולגו',
  'import.problems': 'שורות שלא ייובאו',
  'import.line': 'שורה {line}',
  'import.done': 'יובאו {count} רשומות',
  'import.dryRunNote': 'הבדיקה אינה כותבת דבר. שום דבר לא נשמר עד לאישור.',
  'personnel.importHint':
    'עמודת "שם" היא היחידה שחובה. השאר — מספר אישי, מסגרת, תפקיד, טלפון, הכשירים — אופציונליות.',

  'availability.title': 'זמינות ונוכחות',
  'availability.subtitle':
    'מי לא נמצא ומתי — חופשה, גימלים, קורס או מחלה. המערכת לא תשבץ אדם בזמן שרשום כאן.',
  'availability.add': 'רישום זמינות',
  'availability.request': 'בקשת שינוי זמינות',
  'availability.edit': 'עריכת הרישום',
  'availability.delete': 'מחיקה',
  'availability.deleteConfirm': 'למחוק את רישום {kind} עבור {name}? הפעולה אינה הפיכה.',
  'availability.kind': 'סוג',
  'availability.from': 'מתאריך',
  'availability.to': 'עד תאריך',
  'availability.reason': 'סיבה',
  'availability.status': 'סטטוס',
  'availability.pending': 'ממתין לאישור',
  'availability.approved': 'מאושר',
  'availability.rejected': 'נדחה',
  'availability.approve': 'אישור',
  'availability.reject': 'דחייה',
  'availability.empty':
    'אין רישומי זמינות בטווח שנבחר. כל עוד אין רישום — כולם נחשבים זמינים לשיבוץ.',
  'availability.person': 'אדם',
  'availability.range': 'טווח',
  'availability.allStatuses': 'כל הסטטוסים',
  'availability.import': 'ייבוא מקובץ',
  'availability.importTitle': 'ייבוא זמינות מקובץ CSV',
  'availability.importHint':
    'קובץ עם שם (או מספר אישי), סוג ההיעדרות ותאריכים. תאריך בודד מכסה את כל היום. מי שלא נמצא במאגר או שיש שניים בשמו — ידולג ויופיע בדוח.',

  'assignments.title': 'משימות',
  'assignments.types': 'סוגי משימות',
  'assignments.typesSubtitle':
    'התבניות שמהן בונים את השבצ״ק — סיור, ש.ג, נחל שכם, כרמל, יזומה. כל תבנית קובעת כמה אנשים דרושים, לכמה זמן ואילו הכשירים חייבים להיות בצוות.',
  'assignments.type': 'סוג משימה',
  'assignments.typePlaceholder': 'בחרו סוג משימה…',
  'assignments.noTypes': 'טרם הוגדרו סוגי משימות. הגדירו אחד במסך "סוגי משימות" לפני יצירת משימה.',
  'assignments.anyUnit': 'כל המסגרות',
  'assignments.advanced': 'אפשרויות נוספות',
  'assignments.crews': 'סבבים קבועים',
  'assignments.crewsMenuHint': 'צוותים שעולים ביחד — למשל חפ״ק.',
  'assignments.crewsHint':
    'המשמרת עולה כצוות שלם. רק חברי הסבבים יכולים לעמוד במשימה, ואין מערבבים שני סבבים במשמרת אחת.',
  'assignments.crewsEmpty': 'אין סבבים למשימה הזו — כל מי שמתאים יכול להיות משובץ אליה.',
  'assignments.crewName': 'שם הסבב',
  'assignments.crewNumbered': 'סבב {number}',
  'assignments.crewSeat': 'תפקיד בסבב',
  'assignments.crewSeatPlain': 'לוחם',
  'assignments.addCrew': 'הוספת סבב',
  'assignments.removeCrew': 'מחיקת הסבב',
  'assignments.addCrewMember': 'הוספת איש לסבב',
  'assignments.removeCrewMember': 'הסרה מהסבב',
  'assignments.advancedHint':
    'שם, מסגרת, כמות אנשים, שעת סיום והערות — ברירות המחדל נלקחות מסוג המשימה.',
  'assignments.preview': 'מה ייווצר',
  'assignments.previewOne': 'משימה אחת, {range}.',
  'assignments.previewShifts':
    '{count} משמרות ביום ({times}), בכל יום עד {until}. סה״כ {total} משימות.',
  'assignments.previewFullDay':
    'משמרת אחת של 24 שעות בכל יום, מ־{times}, עד {until}. סה״כ {total} משימות.',
  'assignments.previewDaily': 'משימה אחת בכל יום עד {until}. סה״כ {total} משימות.',
  'assignments.previewIncomplete': 'בחרו סוג משימה ותאריך כדי לראות מה ייווצר.',
  'assignments.standing': 'משימה קבועה',
  'assignments.standingHint':
    'משימה שמאוישת ברציפות מסביב לשעון. המשמרות שלה נפרסות לכל התקופה בלחיצה אחת ממסך השבצ״ק.',
  'assignments.standingBadge': 'קבועה',
  'assignments.shiftHours': 'אורך משמרת',
  'assignments.shiftHoursOption': 'כל {hours} שעות',
  'assignments.shiftStartHour': 'שעת ההתחלפות הראשונה',
  'assignments.briefingMinutesBefore': 'תדריך לפני כל משמרת',
  'assignments.briefingMinutesBeforeHint':
    'אם מוגדר, כל משמרת תוצג עם הערת תדריך בשעה המתאימה לפני תחילתה.',
  'assignments.sheetSection': 'מיקום בגיליון',
  'assignments.section': 'שער',
  'assignments.sectionHint': 'אם מוגדר, השער יופיע ככותרת הכרטיס והמשמרות ייקראו על שם העמדה.',
  'assignments.sheetLabel': 'כותרת בגיליון',
  'assignments.sheetLabelHint': 'מה שיודפס בשורת הכותרת, אם שונה משם העמדה.',
  'assignments.crewRoleSuffix': 'סיומת לתפקידי הצוות',
  'assignments.crewRoleSuffixHint': 'למשל ״סיור״ — ואז מפקד נקרא מפקד סיור בעמדה הזו בלבד.',
  'assignments.maxContinuous': 'אורך תורנות מרבי (שעות)',
  'assignments.maxContinuousHint':
    'למשימה שנמסרת פעם ביום — 24. ריק משאיר את כלל הפלוגה (8 שעות), ואז שיבוץ אוטומטי לא ישבץ אף אחד למשמרת ארוכה ממנו.',
  'assignments.sheetColumn': 'עמודה בגיליון',
  'assignments.sheetColumnAuto': 'לפי מקום פנוי',
  'assignments.sheetColumnOption': 'עמודה {column}',
  'assignments.shiftStartMinute': 'דקות אחרי השעה',
  'assignments.briefingMinutesBeforeNone': 'ללא תדריך',
  'assignments.briefingMinutesBeforeOption': '{minutes} דקות לפני',
  'assignments.excludedQualifications': 'סימונים הפוסלים שיבוץ',
  'assignments.excludedHint':
    'מי שמסומן כך לא ישובץ למשימה הזאת. למשל: לסיור לא משבצים מי שמסומן מבצעים, ולש״ג לא משבצים מפקד.',
  'assignments.addType': 'סוג משימה חדש',
  'assignments.deleteType': 'מחיקת סוג המשימה',
  'assignments.deleteTypeConfirm': 'סוג המשימה "{name}" יימחק. הפעולה אינה הפיכה.',
  'assignments.deleteTypeDone': 'סוג המשימה נמחק.',
  'assignments.deleteTypeWithShiftsConfirm':
    'סוג המשימה "{name}" יימחק יחד עם {count} המשמרות שנוצרו ממנו וכל השיבוצים שלהן. הפעולה אינה הפיכה.',
  'assignments.deleteTypeWithShiftsDone': 'סוג המשימה נמחק, יחד עם {count} משמרות.',
  'assignments.deleteTypeAcceptShiftLoss': 'אני מאשר שגם {count} המשמרות והשיבוצים שלהן יימחקו.',
  'assignments.deleteTypeInUse':
    'אי אפשר למחוק — כבר נוצרו {count} משמרות מסוג המשימה הזה, ומחיקה הייתה מוחקת גם אותן מהלוח ומההיסטוריה.',
  'assignments.retireType': 'השבתת סוג המשימה',
  'assignments.retireTypeHint':
    'סוג משימה מושבת לא מוצע יותר ביצירת משימה ולא נפרס לתקופה, אבל משמרות שכבר נוצרו ממנו נשארות בלוח.',
  'assignments.retireTypeDone': 'סוג המשימה הושבת.',
  'assignments.restoreType': 'הפעלה מחדש',
  'assignments.restoreTypeDone': 'סוג המשימה הופעל מחדש.',
  'assignments.typeUsage': 'נוצרו ממנו {count} משמרות',
  'assignments.typeShiftsCreated': 'משמרות שנוצרו',
  'assignments.typeUnused': 'טרם נוצרו ממנו משמרות',
  'assignments.name': 'שם המשימה',
  'assignments.category': 'קטגוריה',
  'assignments.duration': 'משך משמרת (שעות)',
  'assignments.durationHint':
    'ברירת המחדל של המשימה — 8 לשמונה שעות, 4 לרביעייה. אפשר גם חצי שעה (0.5).',
  'assignments.headcountHint': 'כמה אנשים צריך בכל משמרת של המשימה הזאת.',
  'assignments.headcount': 'כמות אנשים נדרשת',
  'assignments.priority': 'עדיפות',
  'assignments.instructions': 'הנחיות',
  'assignments.requiredQualifications': 'הכשירים נדרשים',
  'assignments.qualificationScopeAll': 'כל המשובצים',
  'assignments.qualificationScopeSome': 'לפחות {count} מהצוות',
  'assignments.qualificationHint':
    'בחרו כמה מתוך הצוות חייבים להחזיק בכל הכשיר. "כל המשובצים" מחייב את כולם.',
  'assignments.date': 'תאריך',
  'assignments.startTime': 'שעת התחלה',
  'assignments.endTime': 'שעת סיום',
  'assignments.endsNextDay': 'מסתיימת למחרת',
  'assignments.nextDayShort': 'למחרת',
  'assignments.notes': 'הערות',
  'assignments.recurrence': 'חזרתיות',
  'assignments.recurrenceNone': 'ללא',
  'assignments.recurrenceDaily': 'כל יום',
  'assignments.recurrenceWeekdays': 'ימים נבחרים',
  'assignments.recurrenceUntil': 'עד תאריך',
  'assignments.shiftRotation': 'משמרות סובבות',
  'assignments.shiftRotationOff': 'ללא — מופע אחד ביום',
  'assignments.shiftEvery': 'התחלפות כל {hours} שעות',
  'assignments.shiftRotationHint': 'המשימה תאויש ברציפות, {count} משמרות ביממה.',
  'assignments.shiftRotationHintOne': 'המשימה תאויש ברציפות, משמרת אחת של 24 שעות ביממה.',
  'assignments.shiftRotationOffHint': 'המשימה תיווצר פעם אחת בכל יום נבחר.',
  'assignments.create': 'יצירת משימה',
  'assignments.assigned': 'משובצים',
  'assignments.candidates': 'מועמדים מוצעים',
  'assignments.candidatesHint':
    'מדורגים לפי התאמה ועומס. מתחת לכל שם מופיעה הסיבה לדירוג, ומי שחסום לשיבוץ מסומן באדום. הבחירה הסופית שלכם.',
  'assignments.noAssignees': 'עדיין לא שובץ אף אחד למשימה. בחרו מתוך המועמדים שלמטה.',
  'assignments.noCandidates':
    'אין מועמדים למשימה הזאת. בדקו שיש אנשים במאגר, שהם זמינים בשעות האלה ושיש להם ההכשירים הנדרשים.',
  'assignments.score': 'ציון התאמה {score}',
  'assignments.eligible': 'זמין לשיבוץ',
  'assignments.ineligible': 'חסום לשיבוץ',
  'assignments.assign': 'שיבוץ',
  'assignments.empty': 'אין משימות להצגה.',
  'assignments.typesEmpty':
    'עדיין לא הוגדרו סוגי משימות. התחילו מסוג אחד — למשל "סיור" עם 4 אנשים, שדורש נהג ומפקד.',
  'assignments.cancel': 'ביטול משימה',
  'assignments.cancelConfirm': 'לבטל את המשימה? הפעולה תתועד ביומן.',
  'assignments.acknowledge': 'אישור קבלה',
  'assignments.acknowledged': 'אושר',

  'conflicts.title': 'התנגשויות שיבוץ',
  'conflicts.subtitle':
    'מה שהמערכת מצאה בשבצ״ק — חפיפה בין משימות, מנוחה קצרה מדי, הכשיר חסר או תת־איוש.',
  'conflicts.blocking': 'חוסמות',
  'conflicts.warning': 'אזהרות',
  'conflicts.info': 'מידע',
  'conflicts.none': 'לא נמצאו התנגשויות בטווח שנבחר.',
  'conflicts.resolution': 'דרך הפתרון',
  'conflicts.override': 'עקיפת החסימה',
  'conflicts.overrideReason': 'נימוק לעקיפה',
  'conflicts.overrideRequired': 'עקיפה מחייבת נימוק שיתועד ביומן.',
  'conflicts.affected': 'נוגע ל־',

  'replacements.title': 'בקשות החלפה',
  'replacements.subtitle':
    'חייל שלא יכול להגיע למשמרת מבקש מחליף. אישור הבקשה מחליף את המשובץ בשבצ״ק.',
  'replacements.request': 'בקשת החלפה',
  'replacements.reason': 'סיבה',
  'replacements.replacement': 'מחליף',
  'replacements.pickReplacement': 'בחרו מחליף כדי לאשר את הבקשה.',
  'replacements.approve': 'אישור החלפה',
  'replacements.reject': 'דחייה',
  'replacements.empty': 'אין בקשות החלפה פתוחות. בקשה נפתחת ממסך "השבצ״ק שלי" של החייל.',
  'replacements.statusPending': 'ממתין',
  'replacements.statusProposed': 'הוצע מחליף',
  'replacements.statusApproved': 'אושר',
  'replacements.statusRejected': 'נדחה',
  'replacements.statusCancelled': 'בוטל',
  'replacements.filter': 'הצגה',
  'replacements.filterOpen': 'פתוחות',
  'replacements.filterAll': 'כל הבקשות',
  'replacements.emptyFiltered': 'אין בקשות במצב שנבחר.',
  'replacements.send': 'שליחת הבקשה',
  'replacements.sent': 'הבקשה נשלחה למפקד.',
  'replacements.sentToPeer': 'הבקשה נשלחה — ממתינה לאישור המחליף.',
  'replacements.standIn': 'מי יחליף אותך',
  'replacements.standInHint': 'מוצגים רק מי שיכולים לקחת את המשמרת הזו בפועל.',
  'replacements.letCommanderChoose': 'שהמפקד יחליט',
  'replacements.noCover': 'אין כרגע מי שיכול לקחת את המשמרת — המפקד יטפל בבקשה.',
  'replacements.reasonHint': 'לא חובה. עוזר למפקד להחליט.',
  'replacements.askedOfYou': 'ביקשו ממך להחליף',
  'replacements.askedOfYouHint': 'אתם נבחרתם כמחליפים. התשובה שלכם היא שלכם — המפקד עדיין מאשר.',
  'replacements.accept': 'אני יכול',
  'replacements.decline': 'לא אוכל',
  'replacements.accepted': 'המחליף אישר',
  'replacements.awaitingPeer': 'ממתין לתשובת המחליף',
  'replacements.answered': 'התשובה נשלחה',
  'replacements.mine': 'הבקשות שלי',
  'replacements.mineHint': 'בקשות החלפה שפתחתם ועדיין לא הוכרעו.',
  'replacements.withdraw': 'ביטול הבקשה',
  'replacements.withdrawn': 'הבקשה בוטלה.',
  'replacements.awaitingCommander': 'ממתין להחלטת המפקד',
  'volunteers.title': 'מתנדבים למשמרות',
  'volunteers.hint': 'אנשים שהציעו לקחת מקום פנוי. השיבוץ נכתב רק כשמאשרים.',
  'volunteers.openSeats': 'מקומות פנויים שאפשר לקחת',
  'volunteers.openSeatsHint':
    'משמרות בשבוע הקרוב שחסר בהן אדם ושאתם יכולים לעמוד בהן בפועל — נבדק מול אותם כללים שיאשרו את השיבוץ.',
  'volunteers.none': 'אין כרגע מקום פנוי שמתאים לכם.',
  'volunteers.offer': 'אני יכול לקחת',
  'volunteers.offered': 'ההצעה נשלחה למפקד.',
  'volunteers.myOffers': 'ההצעות שלי',
  'volunteers.withdraw': 'ביטול ההצעה',
  'volunteers.withdrawn': 'ההצעה בוטלה.',
  'volunteers.accept': 'אישור ושיבוץ',
  'volunteers.decline': 'לא נדרש',
  'volunteers.empty': 'אין הצעות פתוחות.',
  'volunteers.statusOffered': 'הוצע',
  'volunteers.statusAccepted': 'אושר',
  'volunteers.statusDeclined': 'לא נדרש',
  'volunteers.statusWithdrawn': 'בוטל',
  'volunteers.plainSeat': 'מקום פנוי',

  'notifications.title': 'התראות',
  'notifications.subtitle': 'עדכונים על פרסום שבצ״ק, שינויי שיבוץ ובקשות שממתינות לך.',
  'notifications.markAllRead': 'סימון הכול כנקרא',
  'notifications.empty': 'אין התראות חדשות.',
  'notifications.unread': '{count} חדשות',

  'reports.title': 'דוחות',
  'reports.subtitle': 'כמה שעות עשה כל אחד, כמה מהן לילה וסופ״ש, ואיפה נשארו פערי איוש.',
  'reports.workload': 'עומס כוח אדם',
  'reports.totalHours': 'סה״כ שעות',
  'reports.nightHours': 'שעות לילה',
  'reports.weekendHours': 'שעות סופ״ש',
  'reports.assignmentCount': 'מספר שיבוצים',
  'reports.fairnessScore': 'ציון עומס',
  'reports.staffingGaps': 'פערי איוש',
  'reports.export': 'ייצוא',
  'reports.exportExcel': 'קובץ Excel',
  'reports.exportCsv': 'קובץ CSV',
  'reports.exportPrint': 'הדפסה או PDF',
  'reports.exportExcelHint': 'שני גיליונות: עומס ופערי איוש.',
  'reports.exportPrintHint': 'נפתח חלון ההדפסה של הדפדפן — משם אפשר לשמור כ־PDF.',
  'reports.sheetWorkload': 'עומס',
  'reports.sheetGaps': 'פערי איוש',
  'reports.printTitle': 'דוח עומס — {from} עד {to}',
  'reports.gapMissing': 'חסרים',
  'reports.range': 'טווח',
  'reports.rangeDays': '{days} ימים אחרונים',
  'reports.empty': 'אין נתונים בטווח שנבחר.',
  'reports.balance': 'מאזן עומסים',
  'reports.balanceHint': 'לא כמה עשה כל אחד, אלא האם החלוקה הוגנת — ומי נושא יותר מהאחרים.',
  'reports.measure': 'נמדד לפי',
  'reports.median': 'החציון',
  'reports.medianHint': 'האמצע, לא הממוצע — אדם אחד עמוס מסיט ממוצע',
  'reports.spread': 'הפער בין הקצוות',
  'reports.spreadHint': 'בין העמוס ביותר לפנוי ביותר',
  'reports.topFifth': 'החמישית העליונה',
  'reports.topFifthHint': 'חלוקה שווה היא 20%',
  'reports.heaviest': 'העמוס ביותר',
  'reports.lightest': 'הפנוי ביותר',
  'reports.deviation': 'סטייה מהחציון',
  'reports.balanceEven': 'החלוקה סבירה.',
  'reports.balanceUneven': 'השבצ״ק נשען על מעטים — כדאי להסיט משמרות למי שמתחת לחציון.',
  'reports.hoursUnit': 'שעות',

  'settings.title': 'הגדרות',
  'settings.subtitle': 'הבסיס שהשבצ״ק נשען עליו — מסגרות, הכשירים, כללי שיבוץ ויומן הפעולות.',
  'settings.organization': 'ארגון',
  'settings.units': 'מסגרות',
  'settings.qualifications': 'הכשירים',
  'settings.rules': 'כללי שיבוץ',
  'settings.users': 'משתמשים',
  'settings.usersHint':
    'מי יכול להיכנס למערכת ומה מותר לו. חשבון חדש נכנס עם הסיסמה שתקבעו כאן — מסרו אותה בערוץ מוגן.',
  'settings.addUser': 'הוספת משתמש',
  'settings.editUser': 'עריכת משתמש',
  'settings.userEmail': 'שם משתמש לכניסה',
  'settings.userEmailHint': 'אותיות באנגלית, ספרות, נקודה או מקף — או כתובת דוא״ל.',
  'settings.userRole': 'הרשאה',
  'settings.userPersonnel': 'מקושר לאיש כוח אדם',
  'settings.userPersonnelHint': 'קישור מאפשר למשתמש לראות את השבצ״ק האישי שלו ולבקש החלפות.',
  'settings.userScope': 'מסגרות באחריותו',
  'settings.userScopeHint': 'בלי בחירה — רואה את כל המסגרות.',
  'settings.userScopeAll': 'כל המסגרות',
  'settings.userScopeCount': '{count} מסגרות',
  'settings.userActive': 'חשבון פעיל',
  'settings.userInactive': 'מושבת',
  'settings.userDeactivate': 'השבתת חשבון',
  'settings.userActivate': 'הפעלת חשבון',
  'settings.userPassword': 'סיסמה',
  'settings.userPasswordHint': 'לפחות 12 תווים.',
  'settings.userResetPassword': 'איפוס סיסמה',
  'settings.userResetPasswordHint':
    'השארה ריק — הסיסמה לא תשתנה. שינוי מנתק את המשתמש מכל המכשירים.',
  'settings.userLastLogin': 'כניסה אחרונה',
  'settings.userNeverLoggedIn': 'טרם נכנס',
  'settings.userMfa': 'אימות דו־שלבי',
  'settings.usersEmpty': 'יש רק את החשבון שאיתו נכנסתם. הוסיפו משתמש כדי לתת גישה לעוד מישהו.',
  'settings.userSelf': 'זה אתם',

  'account.changePassword': 'שינוי סיסמה',
  'account.currentPassword': 'סיסמה נוכחית',
  'account.newPassword': 'סיסמה חדשה',
  'account.confirmPassword': 'אימות סיסמה חדשה',
  'account.passwordChanged': 'הסיסמה שונתה. שאר המכשירים נותקו.',
  'account.passwordHint': 'לפחות 12 תווים. אחרי השינוי תישארו מחוברים כאן בלבד.',
  'settings.security': 'אבטחה',
  'settings.audit': 'יומן פעולות',
  'settings.configMinutes': 'דקות',
  'settings.configCount': 'כמות',
  'settings.configHours': 'שעות',
  'settings.configWindowDays': 'בתוך כמה ימים',
  'settings.buildRef': 'גרסת המערכת: {ref}',
  'settings.rulesHint': 'הכללים ניתנים להגדרה — קבעו מה חוסם, מה מזהיר ומה רק מדווח.',
  'settings.ruleEnabled': 'פעיל',
  'settings.ruleSeverity': 'חומרה',
  'settings.ruleOverridable': 'ניתן לעקיפה',
  'settings.unitsHint':
    'המבנה הארגוני — פלוגה, מחלקות וצוותים. כל אדם משויך למסגרת, ואפשר לסנן ולשבץ לפיה.',
  'settings.qualificationsHint':
    'מה אדם מוסמך לעשות — נהג, מפקד, חובש, קשר. סוג משימה יכול לדרוש הכשיר, והמערכת לא תשבץ מי שאין לו אותו.',
  'settings.auditHint': 'כל פעולה במערכת נרשמת כאן ואי אפשר למחוק או לשנות רשומה.',
  'settings.addUnit': 'הוספת מסגרת',
  'settings.addQualification': 'הוספת הכשיר',
  'settings.removeQualification': 'מחיקת ההכשיר',
  'settings.removeQualificationHint':
    'הכשיר שאף אחד לא מחזיק בו ושום משימה לא דורשת או פוסלת — נמחק. אחרת יש למזג אותו להכשיר אחר.',
  'settings.qualificationInUse': 'ההכשיר בשימוש, ולכן אי אפשר פשוט למחוק אותו:',
  'settings.usageHeldBy': '{count} אנשים מחזיקים בו',
  'settings.usageRequiredBy': '{count} סוגי משימה דורשים אותו',
  'settings.usageExcludedBy': '{count} סוגי משימה פוסלים אותו',
  'settings.usageSeats': '{count} שיבוצים רשומים עליו כתפקיד',
  'settings.mergeInto': 'מיזוג אל',
  'settings.mergeIntoHint':
    'שני הכשירים שמשמעותם אחת — מי שמחזיק בזה יחזיק בזה, וכל דרישה או פסילה עוברות אליו.',
  'settings.mergeIntoNone': 'ללא מיזוג — מחיקה בלבד',
  'settings.mergeAndRemove': 'מיזוג ומחיקה',
  'settings.qualificationRemoved': 'ההכשיר נמחק.',
  'settings.qualificationMerged': 'ההכשיר מוזג ונמחק.',
  'settings.exclusive': 'הכשיר ייעודי',
  'settings.exclusiveHint':
    'מי שמחזיק בהכשיר ייעודי משובץ אך ורק למשימות שדורשות אותו. כך חמ״ל עושה חמ״ל ולא כלום אחר.',
  'settings.blocksScheduling': 'אינו משובץ למשימות',
  'settings.blocksSchedulingHint':
    'סימון שמוציא את מי שמחזיק בו מסבב המשימות לגמרי — כמו מפלג, שיש לו תפקיד ולא משמרת.',
  'settings.blocksSchedulingBadge': 'לא בסבב',
  'settings.exclusiveBadge': 'ייעודי',
  'settings.unitKindCompany': 'פלוגה',
  'settings.unitKindPlatoon': 'מחלקה',
  'settings.unitKindTeam': 'צוות',
  'settings.parentUnit': 'מסגרת אב',
  'settings.code': 'קוד',

  'audit.title': 'יומן פעולות',
  'audit.actor': 'מבצע',
  'audit.action': 'פעולה',
  'audit.entity': 'ישות',
  'audit.time': 'זמן',
  'audit.details': 'פרטים',
  'audit.empty': 'אין רשומות ביומן בטווח שנבחר.',
  'audit.immutable': 'רשומות היומן אינן ניתנות לעריכה או למחיקה.',

  'me.title': 'השבצ״ק שלי',
  'me.subtitle': 'המשמרות הקרובות שלך והזמינות שדיווחת.',
  'me.upcoming': 'המשימות הקרובות שלי',
  'me.notLinked':
    'החשבון הזה אינו מקושר לחייל במאגר כוח האדם, ולכן אין לו שבצ״ק אישי. מנהל המערכת יכול לקשר חשבון לאיש כוח אדם במסך המשתמשים.',
  'me.noAssignments': 'אין לך משימות בטווח הקרוב.',
  'me.myAvailability': 'הזמינות שלי',
  'me.calendar': 'יומן אישי',
  'me.calendarIntro':
    'קישור לשיבוצים שלך, שנקרא ישירות מהיומן בטלפון. היומן מתעדכן לבד, ומתריע שעה לפני כל משמרת — גם כשהאפליקציה סגורה.',
  'me.calendarIssue': 'הפקת קישור',
  'me.calendarReissue': 'הפקת קישור חדש',
  'me.calendarRevoke': 'ביטול הקישור',
  'me.calendarIssuedAt': 'הקישור הופק ב־{date}',
  'me.calendarNone': 'עוד לא הופק קישור.',
  'me.calendarCopy': 'העתקה',
  'me.calendarCopied': 'הקישור הועתק',
  'me.calendarOnce':
    'זה המקום היחיד שבו הקישור מוצג. העתיקו אותו עכשיו — אם ייעלם, הפיקו קישור חדש.',
  'me.calendarHow': 'בטלפון: הגדרות היומן ← הוספת יומן ← הרשמה לפי כתובת. הדביקו את הקישור.',
  'me.calendarSecret': 'הקישור פותח את השיבוצים שלך לכל מי שמחזיק בו. אל תשתפו אותו.',
  'me.calendarReissueWarns': 'הפקת קישור חדש מבטלת את הקודם — יומן שכבר נרשם יפסיק להתעדכן.',
  'me.calendarNotLinked': 'רק חשבון המשויך לאיש כוח אדם יכול להפיק יומן.',

  'state.loading': 'טוען נתונים…',
  'state.errorTitle': 'לא הצלחנו לטעון את המסך',
  'state.errorBody': 'אירעה שגיאה בעת פנייה לשרת.',
  'state.emptyTitle': 'אין נתונים להצגה',
  'state.forbiddenTitle': 'אין הרשאה',
  'state.forbiddenBody': 'המסך הזה אינו פתוח למשתמש שלך.',
  'state.notFound': 'הדף לא נמצא.',
  'state.savedTitle': 'הפעולה בוצעה',
} as const;

export type TranslationKey = keyof typeof he;
